
export type TweetResponseContent = {
  mentions?: string[];
  /**
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
};
